import { useCallback, useRef, useState } from 'react';

const getErrorMessage = (error: unknown): Error => {
    if (error instanceof Error) {
        return error;
    }
    return new Error('予期せぬエラーが発生しました。');
};

const defaultErrorHandler = (error: Error) => {
    alert(error.message);
};

const useSubmit = <T>(
    runner: () => Promise<T>,
    onError: (error: Error) => void = defaultErrorHandler
): {
    isSubmitting: boolean;
    submit: () => Promise<T | undefined>;
} => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);

    const submit = useCallback(async (): Promise<T | undefined> => {
        if (isSubmittingRef.current) {
            return undefined;
        }

        isSubmittingRef.current = true;
        setIsSubmitting(true);

        try {
            return await runner();
        } catch (error) {
            onError(getErrorMessage(error));
            return undefined;
        } finally {
            isSubmittingRef.current = false;
            setIsSubmitting(false);
        }
    }, [runner, onError]);

    return { isSubmitting, submit };
};

export default useSubmit;
